<template>
    <div>
        <Toast :show="toast.show" :message="toast.message" :tipe="toast.tipe" @close="toast.show = false" :position="toast.position"></Toast>
        <!-- App Header -->
        <div class="appHeader">
            <div class="left">
                <router-link :to="{name:'account'}" class="headerButton">
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">Developer H2H</div>
        </div>
        <!-- * App Header -->
        <!-- App Capsule -->
        <div id="appCapsule" v-if="loading.app == false">
            <div v-if="customer.role == 'H2H'">
                <div class="section full mt-1">
                    <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">IP Address</label>
                                <input type="tel" class="form-control" placeholder="192.168.1.1" v-model="data.ip">
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                            <small class="text-danger" v-if="errors.ip"><i>{{ errors.ip[0] }}</i></small>
                        </div>
                        <div class="form-group basic">
                            <div class="input-wrapper">
                                <label class="label">URL Callback</label>
                                <input type="text" class="form-control" placeholder="https://domain.com/callback" v-model="data.url_callback">
                                <i class="clear-input">
                                    <ion-icon name="close-circle"></ion-icon>
                                </i>
                            </div>
                            <small class="text-danger" v-if="errors.url_callback"><i>{{ errors.url_callback[0] }}</i></small>
                        </div>
                    </div>
                </div>
                <div class="section full mt-1">
                    <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                        <div class="form-group basic">
                            <label class="label">APIKEY</label>
                            <div class="input-group">
                                <input type="text" class="form-control this-copy" v-model="data.api_key" readonly>
                                <div class="input-group-append">
                                    <span class="input-group-text">
                                        <button class="btn btn-primary-outline btn-sm" @click="copy"><ion-icon name="copy-outline"></ion-icon></button>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="custom-control custom-checkbox mb-1">
                            <input type="checkbox" class="custom-control-input" id="check_reset" v-model="data.check_reset">
                            <label class="custom-control-label" for="check_reset"><i>Check Untuk Mereset API KEY</i></label>
                        </div>
                    </div>
                </div>
                <div class="section full mt-1">
                    <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                        <button class="btn btn-primary btn-block btn-lg" @click="showDialog('show')">Simpan</button>
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="section full mt-1">
                    <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                        <div class="text-center">
                            <p>Layanan Developer H2H hanya dapat digunakan oleh pengguna dengan status <b>DIGI H2H</b>, untuk info lebih lengkapnya dan pendaftaran DIGI H2H silahkan hubungi customer service.</p>
                        </div>
                    </div>
                </div>
                <div class="section full mt-1">
                    <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                        <div class="text-center">
                            <p><b>Dokumentasi API</b> dapat dilihat melalui link dibawah ini.</p>
                            <a href="https://documenter.getpostman.com/view/1493836/TVRrV4Uy" target="_blank" class="btn btn-primary btn-block"> Lihat Dokumentasi</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <loading-app v-else></loading-app>

        <Dialog ref="dialog" :loading="dialogLoading" :title="'Simpan'" @confirm="submit()">
            <p>Anda yakin akan menyimpan data ini?</p>
        </Dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex'
import $axios from './../../api.js'
export default {
    name: 'account.data-outlet',
    data() {
        return {
            dialogLoading: false,
            data:{
                ip: '',
                url_callback: '',
                api_key: '',
                check_reset: false
            }
        }
    },
    created() {
        this.getDeveloper()
    },
    computed: {
        ...mapState(['errors','customer','loading','toast'])
    },
    methods: {
        showDialog(value){
            let element = this.$refs.dialog.$el
            window.$(element).modal(value)
        },
        getDeveloper(){
            $axios.get('/developer')
            .then((response) => {
                if(response.data.data != ''){
                    this.data = response.data.data
                }
                this.$store.commit('SET_LOADING', {app:false})
            }).catch((error) => {
                this.$store.commit('SET_LOADING', {app:false})
                this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'danger'})
                setTimeout(() => this.$store.commit('SET_TOAST', {show:false}) , 5000);
            })
        },
        submit(){
            this.$store.commit('CLEAR_ERRORS')
            this.$store.commit('SET_TOAST', {show:false})
            this.dialogLoading = true
            $axios.post('/developer', this.data)
            .then((response) => {
                this.showDialog('hide')
                this.dialogLoading = false
                this.data = response.data.data
                this.$store.commit('SET_TOAST', {show:true,message:response.data.message,tipe:'success'})
            }).catch((error) => {
                if (error.response.status == 422) {
                    this.$store.commit('SET_ERRORS', error.response.data.errors, { root: true })
                }else{
                    this.$store.commit('SET_TOAST', {show:true,message:error.response.data.message,tipe:'danger'})
                }
                this.showDialog('hide')
                this.dialogLoading = false
                
            })
        },
        copy: function (e) {
            let selectEl = window.$(e.target).parents('.input-group').find('.this-copy')[0];
            selectEl.select();
            document.execCommand("copy");
        },
    },
    destroyed() {
        this.$store.commit('CLEAR_ERRORS')
        this.$store.commit('RESET_TOAST')
    },
}
</script>